module.exports = __webpack_public_path__ + "img/Laptop@2x.5221e427.png";